module.exports = __webpack_public_path__ + "img/1572301731.aa6d841d.jpg";